// Unread admin_notifications count for the current user, kept live via
// realtime INSERT + UPDATE subscriptions. Returns 0 when not signed in.

import { useAuth } from "@/hooks/useAuth";
import { getSupabase } from "@/lib/supabase";
import { useEffect, useState } from "react";

export function useAdminUnread() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user?.id) {
      setCount(0);
      return;
    }
    let cancelled = false;
    const sb = getSupabase();

    const refetch = async () => {
      const { count: c } = await sb
        .from("admin_notifications")
        .select("id", { count: "exact", head: true })
        .eq("admin_user_id", user.id)
        .is("read_at", null);
      if (!cancelled) setCount(c ?? 0);
    };

    void refetch();

    const channel = sb
      .channel(`admin-unread-${user.id}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "admin_notifications",
          filter: `admin_user_id=eq.${user.id}`,
        },
        () => void refetch(),
      )
      .subscribe();

    return () => {
      cancelled = true;
      void sb.removeChannel(channel);
    };
  }, [user?.id]);

  return count;
}
